<template>
  <g class="custom-edge" 
    :class="{selected:  isValidationErrorSelected, hovered: isSelected || isValidationErrorHovered, 'in-error': isInError, disabled: disabled}"
    @click="onEdgeClick"
  >
  <g 
      class="invisible-edge"
    >
      <BezierEdge v-bind="computedProps"/>
    </g>
    <g 
      class="under-edge"
    >
      <BezierEdge v-bind="computedProps"/>
    </g>
    <g 
      class="upper-edge"
    >      
      <BezierEdge v-bind="computedProps" />
    </g>
    <g class="edge-button" @click="onButtonClick">
       <!-- Button border -->
      <rect class="border-button" :x="buttonX - (isInError ? 2 : 0)" :y="buttonY - (isInError ? 2 : 0)" :width="buttonSize + (isInError ? 4 : 0)" :height="buttonSize + (isInError ? 4 : 0)" :rx="isInError ? 16 : 14" />
      <!-- Icon Broken Link -->
      <g v-if="isInError" class="broken-link-icon">
        <!-- Button border -->
        <rect :x="buttonX + 2" :y="buttonY + 2" :width="buttonSize - 4" :height="buttonSize - 4" rx="13" stroke="#E15F19" fill="white"/>
        <g :transform="'matrix(1 0 0 1 ' + (buttonX + buttonSize/4 + 1)  + ' ' + (buttonY + buttonSize/4 + 1) +')'">
          <path d="M10 5.99992L10.6667 5.33325" stroke="#E15F19" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5.33301 10.6667L5.99967 10" stroke="#E15F19" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.3947 8.68063L14.0753 7.99996C15.7527 6.32263 15.7527 3.60263 14.0753 1.92463C12.398 0.247292 9.678 0.247292 8 1.92463L7.31934 2.60529" stroke="#E15F19" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.60517 7.31934L1.9245 8C0.24717 9.67734 0.24717 12.3973 1.9245 14.0753C3.60184 15.7527 6.32184 15.7527 7.99984 14.0753L8.68051 13.3947" stroke="#E15F19" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M0.666504 0.666626L15.3332 15.3333" stroke="#E15F19" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </g>
      <!-- Icon Cog -->
      <g v-else>
        <g :transform="'matrix(1 0 0 1 ' + (buttonX - 2)  + ' ' + (buttonY - 2) +')'">
          <!-- Button icon cog -->
          <path 
            d="M25.23 18.9594C25.2967 19.296 25.3333 19.644 25.3333 20C25.3333 20.356 25.2967 20.704 25.23 21.0407L26.434 22.0334C26.7687 22.3094 26.8553 22.788 26.6387 23.164L26.0593 24.1694C25.8427 24.5454 25.3853 24.71 24.9793 24.5574L23.514 24.0074C22.9947 24.4634 22.388 24.8194 21.72 25.0467L21.4633 26.5907C21.3913 27.0194 21.0213 27.3334 20.5873 27.3334H19.4287C18.9947 27.3334 18.6247 27.0194 18.5533 26.5907L18.296 25.0467C17.628 24.8194 17.0213 24.4634 16.502 24.0074L15.0367 24.5574C14.63 24.7094 14.1733 24.5454 13.9567 24.1694L13.3767 23.164C13.16 22.788 13.2467 22.3094 13.5813 22.0334L14.7853 21.0407C14.7187 20.704 14.682 20.3567 14.682 20C14.682 19.6434 14.7187 19.296 14.7853 18.9594L13.5813 17.9667C13.2467 17.6907 13.16 17.212 13.3767 16.836L13.956 15.8307C14.1727 15.4547 14.63 15.29 15.036 15.4427L16.5013 15.9927C17.0207 15.5367 17.6273 15.1807 18.2953 14.9534L18.552 13.4094C18.6247 12.9807 18.9947 12.6667 19.4287 12.6667H20.5873C21.0213 12.6667 21.3913 12.9807 21.4627 13.4094L21.7193 14.9534C22.3873 15.1807 22.9947 15.5367 23.5133 15.9927L24.9787 15.4427C25.3847 15.29 25.842 15.454 26.0587 15.8307L26.638 16.836C26.8547 17.212 26.7687 17.6907 26.4333 17.9667L25.23 18.9594Z" 
            stroke-linecap="round"
            stroke-linejoin="round"
          /> 
          <!-- Button icon cog inner circle -->
          <path 
            :x="buttonX" 
            :y="buttonY" 
            d="M20.0079 18C21.1125 18 22.0079 18.8954 22.0079 20C22.0079 21.1046 21.1125 22 20.0079 22C18.9034 22 18.0079 21.1046 18.0079 20C18.0079 18.8954 18.9034 18 20.0079 18Z"  
            stroke-linecap="round"
            stroke-linejoin="round"
          /> 
        </g>
      </g>
    </g>

  </g>
</template>

<script lang="ts">
import { Vue, prop } from 'vue-class-component';
import { EdgeProps, BezierEdge, EdgeMouseEvent, useVueFlow } from '@vue-flow/core'
import { Options } from 'vue-class-component'
import { APIBlock, APIErrorValidation } from '@/typesAPI';

class Props {
  props: EdgeProps = prop({
    required: true,
  });
}

@Options({
  components: {
    BezierEdge
  },
})
export default class CustomEdge extends Vue.with(Props) {
  buttonSize = 36
  dragLinkPosition = {
    x : 0,
    y : 0
  }
  sourceOrTarget = ''

  vueFlowState = useVueFlow()

  mounted(): void {
    this.props.events.click((edgeMouseEvent:EdgeMouseEvent) => {
      this.$store.dispatch('elements/setSelectedLink', edgeMouseEvent.edge.id)
    })
    this.props.events.mouseEnter((edgeMouseEvent:EdgeMouseEvent) => {
      this.$store.dispatch('elements/setHoveredLink', edgeMouseEvent.edge.id)
    })
    this.props.events.mouseLeave((edgeMouseEvent:EdgeMouseEvent) => {
      this.$store.dispatch('elements/setHoveredLink')
    })
    
    this.$emitter.off('dragLink')
    this.$emitter.on('dragLink', (payload:{x: number, y:number, sourceOrTarget:string}) => {
      if (this.isSelected) {
        this.sourceOrTarget = payload.sourceOrTarget
        const projectedXY = this.vueFlowState.project({x: payload.x, y: payload.y})
        this.dragLinkPosition.x = projectedXY.x
        this.dragLinkPosition.y = projectedXY.y
      }
    })
  }

  get sourceAPIBlock(): APIBlock | undefined {
    return this.$store.getters['blocksAPI/getByID']((this.props as any)?.sourceNode?.extra?.blockAPIID)
  }
  get targetAPIBlock(): APIBlock | undefined {
    return this.$store.getters['blocksAPI/getByID']((this.props as any)?.targetNode?.extra?.blockAPIID)
  }

  get disabled(): boolean {
    return (this.sourceAPIBlock ? !this.sourceAPIBlock.attributes.enabled : false) || (this.targetAPIBlock ? !this.targetAPIBlock.attributes.enabled : false)
  }

  onEdgeClick() {
    this.onButtonClick()
  }

  onButtonClick() {
    this.$store.dispatch('elements/setSelectedLink')
    this.$store.dispatch('elements/setDetailOpenLink')

    this.$store.dispatch('elements/setDetailOpenLink', this.props.id)
  }

  get isSelected() {
    return this.$store.getters['elements/getSelectedLink'] && this.$store.getters['elements/getSelectedLink'].id === this.props.id
  }

  get buttonX() {
    return this.computedProps.sourceX + ((this.computedProps.targetX - this.computedProps.sourceX) / 2) - this.buttonSize/2
  }
  get buttonY() {
    return this.computedProps.sourceY + ((this.computedProps.targetY - this.computedProps.sourceY) / 2) - this.buttonSize/2
  }

  get isDragging () {
    return !!this.$store.getters['elements/getDraggedLink'] && this.$store.getters['elements/getDraggedLink'].id === this.props.id
  }

  get computedProps() {
    return {
      ...this.props,
      sourceX : this.isDragging && this.sourceOrTarget === "source" ? this.dragLinkPosition.x : this.props.sourceX,
      sourceY : this.isDragging && this.sourceOrTarget === "source" ? this.dragLinkPosition.y : this.props.sourceY,
      targetX : this.isDragging && this.sourceOrTarget === "target" ? this.dragLinkPosition.x : this.props.targetX,
      targetY : this.isDragging && this.sourceOrTarget === "target" ? this.dragLinkPosition.y : this.props.targetY
    }
  }

  get errorsValidation (): APIErrorValidation[] {
    return this.$store.getters['errorsValidation/getErrors'].filter((error:APIErrorValidation) => error.relationships.source.data.id === this.computedProps.id)
  }

  get warningsValidation (): APIErrorValidation[] {
    return this.$store.getters['errorsValidation/getWarnings'].filter((error:APIErrorValidation) => error.relationships.source.data.id === this.computedProps.id)
  }

  get isInError():boolean {
    return !!this.errorsValidation.length
  }

  get hoveredError():APIErrorValidation | null {
    return this.$store.getters['errorsValidation/getHoveredError']
  }

  get isValidationErrorHovered(): boolean  {
    return this.hoveredError ? this.hoveredError.relationships.source.data.id === this.computedProps.id : false
  }

  get selectedError():APIErrorValidation | null {
    return this.$store.getters['errorsValidation/getSelectedError']
  }

  get isValidationErrorSelected(): boolean  {
    return this.selectedError ? this.selectedError.relationships.source.data.id === this.computedProps.id : false
  }

}
</script>

<style lang="scss">
@import '@/css/variables';

.custom-edge {
  &.disabled {
    .under-edge, .upper-edge {
      path {
        stroke-dasharray: 5, 5, 5;
      }
    }
  }

  .edge-button {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.1s ease-in-out;
    path {
      transition: stroke 0.1s ease-in-out, fill 0.1s ease-in-out;
      fill: white;
      stroke: $color-brand;
      stroke-width: 1.33;
    }
    .border-button {
      fill: transparent;
    }
  }
  path {
    transition: stroke 0.1s ease-in-out, stroke-width 0.1s ease-in-out, fill 0.1s ease-in-out;
  }
  rect {
    transition: stroke 0.1s ease-in-out, stroke-width 0.1s ease-in-out;
  }
  
  .invisible-edge {
    path {
      stroke-width: 24px !important;
      stroke: transparent !important;
    }
  }


  &.in-error {
    .edge-button {
      pointer-events: all;
      opacity: 1;
      path {
        fill: white;
      }
      .broken-link-icon {
        path {
          stroke: $color-orange;
          stroke-width: 1.33;
        }
      }
    }
    .under-edge {
      path {
        stroke-width: 0px !important;
      }
    }
    .upper-edge {
      path {
        stroke-dasharray: 10;
        stroke: $color-orange !important;
        stroke-width: 2px !important;
      }
    }
  }

  &.selected {
    .under-edge {
      path {
        stroke: $color-brand !important;
        stroke-width: 8px !important;
      }
    }
    .upper-edge {
      path {
        stroke-width: 2px !important;
      }
    }
  }

  &:hover, &.hovered {
    &.in-error {
      .border-button {
        fill: white;
        stroke: $color-brand;
        stroke-width: 4 !important;
      }
    }
    .edge-button {
      pointer-events: all;
      opacity: 1;
      .border-button {
        fill: white;
        stroke: $color-brand;
        stroke-width: 8;
      }
     
      path {
        fill: white;
      }
    }
    .under-edge {
      path {
        stroke: $color-brand !important;
        stroke-width: 16px !important;
        stroke-dasharray: none;
      }
    }
    .upper-edge {
      path {
        stroke-width: 2px !important;
        stroke-dasharray: none;
      }
    }
    &.selected {
      .under-edge {
        path {
          stroke: $color-brand !important;
          stroke-width: 12px !important;
          stroke-dasharray: none;
        }
      }
    }
  }

  
}
</style>
